import request from '@/router/axios.js';

import { userStore } from "@/store/user.js";


/**

 import { getPublickOptions } from '@/util/getoptions';
 
 let arr = ['clinic','employee']
 
 //clinicId 不传默认为当前门店
 getPublickOptions(arr,clinicId).then(res =>{
     console.log('res',res)
     this.clinicList = res[0];
     this.employeeList = res[1];
 })
 **/


const apiurl = [
    {
        name: "employee", //诊所员工
        url: "/api/ygj-chain/v1.0/employee/select",
        callback: (res) => {
          return new Promise((resolve, reject) => {
            resolve(res.data.data);
          });
        },
    },
    {
      name: "qwClinic", //企微诊所列表
      url: "/api/ygj-chain/v1.0/wecom/select-clinic",
      callback: (res) => {
        return new Promise((resolve, reject) => {
          resolve(res.data.data);
        });
      },
    },
    {
      name: "HisClinic", //HIS下租户的所有诊所
      url: "/api/ygj-chain/v1.0/clinic/select-all-list",
      callback: (res) => {
        return new Promise((resolve, reject) => {
          resolve(res.data.data);
        });
      },
    },
    {
      name: "HisWorkClinic", //HIS下租户的员工工作诊所
      url: "/api/ygj-chain/v1.0/wx/clinic/select-emps-list",
      callback: (res) => {
        return new Promise((resolve, reject) => {
          resolve(res.data.data);
        });
      },
    },
    {
      name: "clinicEmpsList", // 诊所员工列表（带门店）
      url: "/api/ygj-chain/v1.0/clinic/select-emps-list",
      callback: (res) => {
        return new Promise((resolve, reject) => {
          resolve(res.data.data);
        });
      },
    },
    {
      name: "doctor", //医生
      url: "/api/ygj-chain/v1.0/employee/doctor-select",
      callback: (res) => {
        return new Promise((resolve, reject) => {
          let { data } = res.data;
  
          data.forEach((row) => {
            row.employeeRealName = row.item.employeeRealName;
            row.employeeName = row.item.employeeName;
          });
  
          resolve(data);
        });
      },
    },
    {
      name: "assistantDoctor", //还是医生列表但助理医生会显示成上级医生/助理医生(当前)，取的都是真实姓名用于预约
      url: "/api/ygj-chain/v1.0/employee/doctor-select",
      callback: (res) => {
        return new Promise((resolve, reject) => {
          let { data } = res.data;
          data.forEach((row) => {
            if (
              row.item.isAssistant == 1 &&
              row.item.preceptorEmployeeName != ""
            ) {
              row.name = `${row.item.preceptorRealName}/${row.item.employeeRealName}`;
            }else{
              row.name = row.item.employeeRealName
            }
            //医生为助理医生且没有上级医生，禁用
            row.disabled = row.item.isAssistant === 1 && row.item.preceptorEmployeeId === "";
          });
          resolve(data);
        });
      },
    },

    {
      name: "assistant", // 助理（岗位编码 P08，见 select-by-postcode）
      url: "/api/ygj-chain/v1.0/employee/select-by-postcode",
      callback: (res) => {
        return new Promise((resolve, reject) => {
          resolve(res.data.data);
        });
      },
    },
    {
      name: "consultant", //咨询师
      url: "/api/ygj-chain/v1.0/employee/consult-select",
      callback: (res) => {
        return new Promise((resolve, reject) => {
          resolve(res.data.data);
        });
      },
    },
    {
      name: "netService", //网电客服
      url: "/api/ygj-chain/v1.0/employee/wdyx-select",
      callback: (res) => {
        return new Promise((resolve, reject) => {
          resolve(res.data.data);
        });
      },
    },
    {
      name: "nurse", //护士
      url: "/api/ygj-chain/v1.0/employee/nurse-select",
      callback: (res) => {
        return new Promise((resolve, reject) => {
          resolve(res.data.data);
        });
      },
    },
    {
      name: "front", //前台
      url: "/api/ygj-chain/v1.0/employee/front-select",
      callback: (res) => {
        return new Promise((resolve, reject) => {
          resolve(res.data.data);
        });
      },
    },
    {
      name: "qwEmployeeAll", //企微员工下拉选择 企微员工包括连锁的？
      url: "/api/ygj-integration/v1.0/wecom-user/select-all-user",
      callback: (res) => {
        return new Promise((resolve, reject) => {
          resolve(res.data.data);
        });
      },
    },
    {
      name: "hisEmployee", //企微员工
      url: "/api/ygj-chain/v2.0/employee/select-employee-list",
      method: "post",
      callback: (res) => {
        return new Promise((resolve, reject) => {
          resolve(res.data.data);
        });
      },
    },
    {
      
      name: "storeWecomStaff", //门店企微员工
      url: "/api/ygj-integration/v1.0/wecom-user/select-clinic-user",
      callback: (res) => {
        return new Promise((resolve, reject) => {
          resolve(res.data.data);
        });
      },
    },
    {
      name: "allService", //获取所有客服
      url: "/api/ygj-chain/v1.0/employee/dedicated-customer-service-select",
      callback: (res) => {
        return new Promise((resolve, reject) => {
          resolve(res.data.data);
        });
      },
    },
    {
      name: "room", //诊室
      url: "/api/ygj-chain/v1.0/clinic/room/select",
      callback: (res) => {
        return new Promise((resolve, reject) => {
          resolve(res.data.data);
        });
      },
    },
    {
      name: "appointItemList", //预约项目
      url: "/api/ygj-appoint/v1.0/appoint/item/select-list",
      callback: (res) => {
        return new Promise((resolve, reject) => {
          resolve(res.data.data);
        });
      },
    },
    {
      name: "qwDepartment", //企微部门
      url: "/api/ygj-integration/v1.0/wecom-department/workplace-tree",
      callback: (res) => {
        return new Promise((resolve, reject) => {
          resolve(res.data.data);
        });
      },
    }
]


//输入类型 返回类型组成的数组
export function getPublickOptions(typeArr, clinicId, params) {
    const user = userStore();

    if (!clinicId) {
      clinicId = user.userInfo.detail.clinic_id;
    }
    let arr = [];
    typeArr.forEach((item) => {
      let object = apiurl.find((item1) => item1.name === item);
      if (object && object.callback) {
        let addUrl = object.url;
        const requestMethod = object.method || "get";

        const requestParams = {
          clinicId,
          ...(params || {}),
        };

        if (item === "assistant") {
          requestParams.postCode = "P08";
        }

        switch(item){
          case "qwClinic":
            addUrl = addUrl + "?corpId=" + user.corpId
            ;
          break;
          case "hisEmployee":
          // 需要携带 employeeTypes =0
           requestParams.employeeTypes = 0;
          break
        }

        const requestConfig = {
          url: addUrl,
          method: requestMethod,
        };

        if (requestMethod === "post") {
          requestConfig.data = requestParams;
        } else {
          requestConfig.params = requestParams;
        }

        arr.push(
          request(requestConfig).then((res) => {
            return object.callback(res);
          })
        );
      } else {
        arr.push(
          request({
            url: object.url,
            method: "get",
            params: {
              clinicId,
              ...params,
            },
          })
        );
      }
    });
    return Promise.all(arr);
  }

